import React from "react";
import debt from "../../components/debt.jpeg";
import debtvalidation from "./debt_verification_and_validation_letter.pdf";

function DebtValidation() {
  return (
    <div className="container">
      <div className="banner">
        <img src={debt} alt="" />
      </div>
      <div className="container_body">
        <div className="course">
          <h1>Debt Validation</h1>
          <p>
            This letter is a template that you can use to request a validation
            of debt from the consumer reporting agencies!
          </p>
        </div>
        <div className="downloads">
          <h3>Downloads</h3>
          <a href={debtvalidation}>
            debt_verification_and_validation_letter.pdf
          </a>
        </div>
      </div>
    </div>
  );
}

export default DebtValidation;
